// extracted by mini-css-extract-plugin
export var backgroundContainmentImage = "CallToActionB-module--backgroundContainmentImage--f48f1";
export var backgroundImage = "CallToActionB-module--backgroundImage--d64bb";
export var content = "CallToActionB-module--content--67189";
export var ctaBottomHeading = "CallToActionB-module--ctaBottomHeading--d52cc";
export var ctaBtn = "CallToActionB-module--ctaBtn--a3983";
export var ctaTopHeading = "CallToActionB-module--ctaTopHeading--6a100";
export var ctaWrapper = "CallToActionB-module--ctaWrapper--1123b";
export var externalWrapper = "CallToActionB-module--externalWrapper--32ecc";
export var headingWrapper = "CallToActionB-module--headingWrapper--92311";
export var wrapper = "CallToActionB-module--wrapper--fd1f1";